


















































import { Component, Prop, Vue } from "vue-property-decorator";

import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";

import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import TextField from "@/components/TextField/TextField.vue";

import { LessonsFormData } from "./Lessons.vue";
import { ILesson } from "@/models/interfaces/lessons";
import { ISchool } from "@/models/interfaces/schools";
import { IVuexState } from "@/models/interfaces/store";
import { IClass, ISubgroup } from "@/models/interfaces/classes";

@Component({
  components: {
    AppHeader,
    AppHeaderBackWithTitle,
    AppContent,

    AsyncButton,
    InputRow,
    TextField
  }
})
export default class LessonsStep3View extends Vue {
  @Prop({ required: true })
  private form!: LessonsFormData;

  @Prop({ required: true })
  private schools!: IVuexState<ISchool[]>;

  @Prop({ required: true })
  private classes!: IVuexState<IClass[]>;

  @Prop({ required: true })
  private lessons!: IVuexState<ILesson[]>;

  @Prop({ required: true, type: Boolean })
  private loading!: boolean;

  get selectedClasses() {
    return (
      this.classes.data?.filter(classData =>
        this.form.classesIds.includes(classData.classId)
      ) ?? []
    );
  }

  get computedClassValue() {
    return this.selectedClasses.map(item => item.className).join(", ");
  }

  get computedSubGroupsValue() {
    const allSubGroups = this.selectedClasses.reduce(
      (subgroups, item) => [...subgroups, ...item.subGroups],
      [] as ISubgroup[]
    );

    return allSubGroups
      .filter(subgroup => this.form.subGroupsIds.includes(subgroup.subGroupId))
      .map(item => item.name)
      .join(", ");
  }

  get computedSchoolValue() {
    const values = this.schools.data!.filter((school: ISchool) =>
      this.form.schoolsIds.includes(school.schoolId)
    );

    return values.map(school => school.schoolName).join(", ");
  }

  get computedLessonsValue() {
    return this.lessons.data!.find(
      item => item.lessonId === Number(this.form.lessonId)
    )!.title;
  }
}
